import { render, staticRenderFns } from "./TksGetGrainNames.vue?vue&type=template&id=5344d789"
import script from "./TksGetGrainNames.vue?vue&type=script&lang=js"
export * from "./TksGetGrainNames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports